import React from 'react';
import { Typography, Tooltip } from "antd";
import { Application, resource } from "@yulintu/freesia-bootstrap";

export default function AppGalleryGalleryItemV(props) {

    props.data.description = props.data.description || "暂无描述";
    let showDescription = props.data.showDescription || props.showDescription;
    if (showDescription === undefined)
        showDescription = true;

    return (
        <Tooltip title={props.data.description || props.data.summary} placement='bottom'>
            <div className="layout-v center app-gallery-item--gallery-item-v" style={{ ...props.data.contentStyle }}>
                <div className="logo" style={{ alignItems: "center", ...props.data.logoStyle }}>
                    {
                        props.data.logoBackgroundSvg && <Application.SvgIcon type={props.data.logoBackgroundSvg} style={{ position: "absolute", fontSize: 130, ...props.data.logoBackgroundSvgStyle }} />
                    }
                    {
                        props.data.logoSvg ? (
                            <Application.SvgIcon type={props.data.logoSvg} style={{ zIndex: 1, ...props.data.logoSvgStyle }} />
                        ) : (
                            <img className="image" src={resource(props.data.logoImage)} style={{ zIndex: 1, ...props.data.logoImageStyle }} />
                        )
                    }
                </div>
                <div className="fill layout-v w100 h0 content" style={{ textAlign: "center" }}>
                    <div className="title text-nowrap text-ellipsis">{props.data.title || props.data.alias}</div>
                    {
                        showDescription && <Typography.Paragraph className="fill h0 description second-text" title={props.data.summary || props.data.description} ellipsis={{ rows: 1, expandable: false }}>
                            {props.data.summary || props.data.description}
                        </Typography.Paragraph>
                    }
                </div>
            </div >
        </Tooltip>
    );
}